import * as React from "react";
import { SVGProps } from "react";

const Akropolis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 148 164"
    {...props}
  >
    <linearGradient
      id="a"
      x1={0}
      x2={148.44}
      y1={137.884}
      y2={137.884}
      gradientTransform="matrix(1 0 0 -1 0 220.012)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#e168fd" />
      <stop offset={1} stopColor="#7b00fc" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M74.2 164.3c-4 0-8-1.1-11.5-3.1l-51.1-29.5C4.4 127.5 0 119.9 0 111.6v-59c0-8.2 4.4-15.9 11.5-20L62.7 3.1C69.8-1 78.6-1 85.8 3.1l51.1 29.5c7.1 4.1 11.5 11.8 11.5 20v59.1c0 8.2-4.4 15.9-11.5 20l-51.1 29.5c-3.6 2-7.5 3.1-11.6 3.1zM74.2 8c-2.6 0-5.2.7-7.5 2L15.5 39.6c-4.7 2.7-7.5 7.7-7.5 13v59.1c0 5.4 2.9 10.3 7.5 13l51.1 29.6c4.7 2.7 10.4 2.7 15.1 0l51.1-29.5c4.6-2.7 7.5-7.6 7.5-13V52.6c0-5.4-2.9-10.4-7.5-13L81.8 10c-2.3-1.3-4.9-2-7.6-2zm0 129.5c-2.2 0-4.3-.6-6.2-1.7l-37.2-21.4c-3.8-2.2-6.2-6.3-6.2-10.8V60.7c0-4.4 2.3-8.5 6.2-10.8L68 28.5c3.9-2.2 8.6-2.2 12.4 0l37.1 21.4c3.8 2.2 6.2 6.3 6.2 10.8v42.9c0 4.4-2.4 8.6-6.2 10.8l-37.2 21.4c-1.8 1.1-3.9 1.7-6.1 1.7zm0-104.7c-1.1 0-2.2.3-3.2.9L33.8 55.1c-2 1.2-3.2 3.3-3.2 5.6v42.9c0 2.3 1.2 4.4 3.2 5.6L71 130.6c2 1.2 4.4 1.2 6.4 0l37.1-21.4c2-1.2 3.2-3.3 3.2-5.6V60.7c0-2.3-1.2-4.4-3.2-5.6L77.4 33.7c-.9-.6-2-.9-3.2-.9zm0 77.5c-1.1 0-2.2-.3-3.2-.8l-18.8-11c-2-1.1-3.2-3.3-3.2-5.5V71.2c0-2.3 1.2-4.4 3.2-5.5L71 54.8c2-1.1 4.4-1.1 6.4 0l18.8 10.9c2 1.1 3.2 3.2 3.2 5.5V93c0 2.3-1.2 4.4-3.2 5.5l-18.8 10.9c-1 .6-2.1.9-3.2.9zm0-52.3c-.4 0-.8.1-1.2.3L54.2 69.2c-.7.4-1.2 1.2-1.2 2V93c0 .8.5 1.6 1.2 2.1L73 106c.7.4 1.6.4 2.4 0l18.8-10.9c.7-.4 1.2-1.3 1.2-2.1V71.2c0-.8-.5-1.6-1.2-2L75.4 58.3c-.4-.2-.8-.3-1.2-.3z"
    />
  </svg>
);

export default Akropolis;
